var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.95201L14 7.95201M14 7.95201L9.66667 12.6665M14 7.95201L9.66667 3.33317",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 3.4203,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgArrow;